module.exports = __webpack_public_path__ + "static/apple_store_badge-9ecec38ac6516be6c0756ced4ea3936e.svg";